export const ticketComplaintColumns = [
    {
        field: "clientNumber",
        headerName: "ClientContact",
        width: 160,
    },
    {
        field: "complaintDetails",
        headerName: "Complaint Details",
        width: 360,
    },
    {
        field: "supportEmployeeName",
        headerName: "Support Employee",
        width: 160
    },
    {
        field: "supportEmployeeEmail",
        headerName: "Support Employee Email",
        width: 160
    },
    {
        field: "supportEmployeeNumber",
        headerName: "Support Employee Number",
        width: 160
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "status",
        headerName: "status",
        width: 120,
    },
  ];